
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ProductFilterOption } from 'src/app/pages/reports/interfaces/report-filters.model';
import { FilterOption } from 'src/app/shared/interfaces/filter-option.interface';

@Component({
    selector: 'app-service-filters-row',
    templateUrl: './service-filters-row.component.html',
    styleUrls: ['./service-filters-row.component.scss']
})
export class ServiceFiltersRowComponent implements OnInit {
    @Input() selectedStatus: FilterOption[] = [];
    @Input() selectedProducts: ProductFilterOption[] = [];
    @Input() rangeValue: Date[] | undefined = undefined;
    @Input() serviceStatusArray: FilterOption[] = [];
    @Input() productsArray: ProductFilterOption[] = [];

    @Output() statusEmitter = new EventEmitter<FilterOption[]>();
    @Output() productsEmitter = new EventEmitter<ProductFilterOption[]>();
    @Output() dateEmitter = new EventEmitter<Date[]>();

    rangeDateConfig = {
        rangeInputFormat: 'DD/MM/YYYY',
        showWeekNumbers: false,
        containerClass: 'theme-default right-aligned-datepicker'
    };

    ngOnInit(): void {
        // Date range is now initialized in parent component
    }

    onStatusChange(event: FilterOption[]): void {
        this.statusEmitter.emit(event);
    }

    onProductChange(event: ProductFilterOption[]): void {
        this.productsEmitter.emit(event);
    }

    onDateRangeChange([from, to]: any) {
        if (!from || !to) return;

        this.dateEmitter.emit([from, to]);
    }
}
